import { IPagination } from '../types/pagination'
import { IAccountingChartData } from '../views/accounting/types/accounting'
import { IDirectCostInvoice, IProjectInvoice } from '../views/project/types/invoice'
import { HttpClient } from './service'
import Urls from './urls'


export const GlobalAccountingApi = {
  /** SPONSOR AND PTC */
  getInvoices(queryParams: Record<string, string>): Promise<IProjectInvoice[]> {
    return HttpClient.get<IProjectInvoice[], Record<string, string>>(Urls.GlobalAccounting.accountingExpenses, queryParams)
  },

  getInvoiceYears(queryParams?: Record<string, string>): Promise<number[]> {
    return HttpClient.get<number[], Record<string, string>>(Urls.GlobalAccounting.accountingInvoiceYears, queryParams)
  },

  getPaginatedInvoices(queryParams: Record<string, string>): Promise<IPagination<IProjectInvoice[]>> {
    return HttpClient.get<IPagination<IProjectInvoice[]>, Record<string, string>>(Urls.GlobalAccounting.accountingExpenses, queryParams)
  },

  getInvoice(projectId: number | string, invoice_id: number | string): Promise<IProjectInvoice> {
    return HttpClient.get<IProjectInvoice, IProjectInvoice>(`${Urls.GlobalAccounting.accountingExpenses}${invoice_id}/`)
  },

  createInvoice(projectId: number | string, invoice: IProjectInvoice): Promise<IProjectInvoice> {
    return HttpClient.post<IProjectInvoice, IProjectInvoice>(Urls.GlobalAccounting.accountingExpenses, invoice)
  },

  updateInvoice(projectId: number | string, invoice: IProjectInvoice): Promise<IProjectInvoice> {
    return HttpClient.put<IProjectInvoice, IProjectInvoice>(Urls.GlobalAccounting.accountingExpenses, invoice.id, invoice)
  },

  deleteInvoice(projectId: number | string, invoice: IProjectInvoice): Promise<string | number> {
    return HttpClient.delete<string | number, string | number>(Urls.GlobalAccounting.accountingExpenses, invoice.id)
  },

  getAccountingChartData(queryParams?: Record<string, string>): Promise<IAccountingChartData> {
    return HttpClient.get<IAccountingChartData, Record<string, string>>(`${Urls.GlobalAccounting.accountingExpenses}chart/`, queryParams)
  },

  /** DC */
  getPaginatedDCInvoices(queryParams: Record<string, string>): Promise<IPagination<IDirectCostInvoice[]>> {
    return HttpClient.get<IPagination<IDirectCostInvoice[]>, Record<string, string>>(Urls.GlobalAccounting.accountingReceipts, queryParams)
  },

  getDCInvoice(projectId: number | string, invoice_id: number | string): Promise<IDirectCostInvoice> {
    return HttpClient.get<IDirectCostInvoice, IDirectCostInvoice>(`${Urls.GlobalAccounting.accountingReceipts}${invoice_id}/`)
  },

  createDCInvoice(projectId: number | string, invoice: IDirectCostInvoice): Promise<IDirectCostInvoice> {
    return HttpClient.post<IDirectCostInvoice, IDirectCostInvoice>(Urls.GlobalAccounting.accountingReceipts, invoice)
  },

  updateDCInvoice(projectId: number | string, invoice: IDirectCostInvoice): Promise<IDirectCostInvoice> {
    return HttpClient.put<IDirectCostInvoice, IDirectCostInvoice>(Urls.GlobalAccounting.accountingReceipts, invoice.id, invoice)
  },

  deleteDCInvoice(projectId: number | string, invoice: IDirectCostInvoice): Promise<string | number> {
    return HttpClient.delete<string | number, string | number>(Urls.GlobalAccounting.accountingReceipts, invoice.id)
  },

  getAccountingReceiptsChartData(queryParams?: Record<string, string>): Promise<IAccountingChartData> {
    return HttpClient.get<IAccountingChartData, Record<string, string>>(`${Urls.GlobalAccounting.accountingReceipts}chart/`, queryParams)
  },
}
